import BillingsTaxiOrderListingByRailyTaxiCorporationSelectOption from "./types/billings-taxi-order-listing-by-raily-taxi-corporation-select-option";
import BillingsTaxiOrderListingFactory from "../../common/billings-taxi-order-listing.factory";
import { TaxiCorporationListItem } from "../../../../../../common/services/taxi-corporation/list/taxi-corporation-list";

const createTaxiCorporationSelectOption = (
  responseTaxiCorporation: TaxiCorporationListItem,
): BillingsTaxiOrderListingByRailyTaxiCorporationSelectOption => {
  return {
    label: responseTaxiCorporation.displayName,
    value: {
      uuid: responseTaxiCorporation.uuid,
      displayName: responseTaxiCorporation.displayName,
    },
  };
};

const createTaxiCorporationSelectOptions = (
  responseTaxiCorporations: TaxiCorporationListItem[],
): BillingsTaxiOrderListingByRailyTaxiCorporationSelectOption[] => {
  return responseTaxiCorporations.map(createTaxiCorporationSelectOption);
};

const billingsTaxiOrderListingByRailyFactory = {
  createTaxiCorporationSelectOptions,
  createListingItems: BillingsTaxiOrderListingFactory.createListingItems,
  createStatsSummary: BillingsTaxiOrderListingFactory.createStatsSummary,
};

export default billingsTaxiOrderListingByRailyFactory;
